<template>
  <div id="home">
    <div class="navbar">
      <div class="main_bar">
        <div class="title">
          Corvus Photo
        </div>
        <div class="menu menu_pc">
          <div class="menu_tab" :class="{ active: (menuIndex === 'home') }" @click="navGo('album')">Album</div>
          <div class="menu_tab" :class="{ active: (menuIndex === 'blog') }" @click="navGo('blog')">Blog</div>
          <div class="menu_tab" :class="{ active: (menuIndex === 'about') }" @click="navGo('about')">About</div>
        </div>
      </div>
      <div class="menu_phone">
        <span class="menu_tab" :class="{ active: (menuIndex === 'home') }" @click="navGo('album')">Album</span>
        <span class="menu_tab" :class="{ active: (menuIndex === 'blog') }" @click="navGo('blog')">Blog</span>
        <span class="menu_tab" :class="{ active: (menuIndex === 'about') }" @click="navGo('about')">About</span>
      </div>
    </div>

    <div class="router-container">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>

  </div>
</template>

<script>

export default {
  name: 'home',
  data () {
    return {
    }
  },
  computed: {
    menuIndex: function () {
      return this.$store.getters.menuIndex;
    },
  },
  methods: {
    navGo: function ( linkName ) {
      this.$router.push({ name: linkName });
    },
  },
}
</script>

<style lang="scss">

  $font-color: #5E5E5E;
  $font-color-light: #9C9C9C;
  $background-color: #F5F5F5;
  $background-color-dark: #EFEFEF;

  h1 {
    line-height: 2.2rem;
  }
  hr {
    border: solid $font-color;
    border-width: 0px 0px 1px 0px;
  }
  .button {
    cursor: pointer;
    display: inline-block;
    background-color: $background-color-dark;
    border: solid $font-color-light;
    border-width: 1px;
    padding: 7px 20px;
    margin: 10px 0;
  }
</style>

<style scoped>
  .navbar {
    color: #444444;
    margin-bottom: 40px;
  }
  .main_bar {
    position: relative;
    height: 60px;
    margin: 0px 50px;
    padding: 20px 20px 10px 20px;
    border: solid #cacaca;
    border-width: 0px 0px 3px 0px;
    background-color: #F5F5F5;
    font-family: fashionFetish;
  }
  .title {
    font-size: 1.5em;
    position: absolute;
    bottom: 0px;
    left: 20px;
    padding: 10px 10px 25px 10px;
  }
  .menu {
    position: absolute;
    bottom: 0px;
    right: 10px;
    font-size: 1em;
  }
  .menu_tab {
    padding: 8px 5px 4px 5px;
    margin: 0 10px;
    display: inline-block;
    border: solid transparent;
    border-width: 2px 0px 2px 0px;
    cursor: pointer;
  }
  .menu_phone {
    color: #CECECE;
    font-family: fashionFetish;
    margin: 0px 10px;
    text-align: center;
    display: none;
  }
  .menu_pc .menu_tab.active {
    border: solid #444444;
    border-width: 0px 0px 2px 0px;
  }
  .menu_phone .menu_tab.active {
    border: solid #cacaca;
    border-width: 2px 0px 0px 0px;
  }

  @media screen and (max-width: 767px) {
    .navbar {
      margin-bottom: 20px;
    }
    .menu_tab {
      padding: 8px 5px 8px 5px;
    }
    .main_bar {
      height: 40px;
      text-align: center;
    }
    .title {
      position: relative;
      left: 0px;
      bottom: 2px;
      padding: 10px;
    }
    .menu_pc {
      display: none;
    }
    .menu_phone {
      display: block;
    }
    .main_bar {
      margin: 0px 10px;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue